import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import { useCallback } from 'react';
import { createInfiniteLoopAdminActionOutbound } from '../../../api/outbound/commonOutbounds';
import { MenuItemContainer } from '../../../components/menuItemContainer';
import { addMessageBox } from '../../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { isLocalhostEnvironment } from '../../../utils/utils';
const ENABLED_ADMIN_IDS = [
    1 // ZenBlender
];
export const PlayerInfiniteLoopAdminMenuItemContainer = ({ playerIdName, closeMenu }) => {
    const dispatch = useAppDispatch();
    const isSelfAdmin = useAppSelector((state) => state.selfData.isAdmin);
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const onClick = useCallback(() => {
        dispatch(addMessageBox({
            type: 'confirm',
            title: `Hit ${playerIdName.name} with an infinite loop?`,
            isHtmlMessage: false,
            showCloseButton: true,
            buttons: [
                {
                    label: 'Do it!',
                    actions: [{ type: 'outbound', outbound: createInfiniteLoopAdminActionOutbound(playerIdName.id) }],
                    closeAfterClick: true
                }
            ]
        }));
    }, [dispatch, playerIdName.id, playerIdName.name]);
    if (!isSelfAdmin || myPlayerId === undefined) {
        return null;
    }
    if (!isLocalhostEnvironment() && !ENABLED_ADMIN_IDS.includes(myPlayerId)) {
        return null;
    }
    return (_jsx(MenuItemContainer, { label: 'Infinite Loop Player', svgIconComponent: AllInclusiveRoundedIcon, onClick: onClick, closeMenu: closeMenu }));
};
